import * as THREE from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import {
  deviceStateManager,
  garmentManager,
  garments,
  loadingScreen,
  overlay,
  patch,
} from "./Experience"

export class Loaders {
  constructor() {
    this.loadingScreenBar = document.querySelector(".loading-bar-progress")

    this.loadingManager = new THREE.LoadingManager(
      //Loaded
      () => {
        deviceStateManager.checkForInitialState()
        garmentManager.setGarmentAnimations()


        // garments.setHoodieAnimations()

        overlay.connectOverlayWithMouse()

        patch.setPatch()
        patch.setPatchBackground()
        patch.setPatchParticles()
        // patch.setSwirls()
        patch.setConnector()

        loadingScreen.fadeOut()
      },

      //Progress
      (itemUrl, itemsLoaded, itemsTotal) => {
        let progress = itemsLoaded / itemsTotal

        this.loadingScreenBar.style.width = `${progress * 100}%`
      }
    )

    this.textureLoader = new THREE.TextureLoader(this.loadingManager)

    this.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingManager)

    this.gltfLoader = new GLTFLoader(this.loadingManager)
  }
}
